/**
 * What HireOS works with, for the integrations page and the hero's row of
 * marks. `ask` marks a popular rental system we don't connect to yet: it is
 * listed so an operator who runs it knows to ask, not as a claim that it works.
 */
export type Integration = {
  name: string;
  kind: "Rental system" | "Calendar" | "Accounting";
  /** In public/logos/. */
  mark: string;
  /** The mark is a full app icon with its own background, so it fills its tile. */
  fill?: boolean;
  ask?: boolean;
};

export const INTEGRATIONS: Integration[] = [
  { name: "Current RMS", kind: "Rental system", mark: "/logos/current-rms-mark.png" },
  { name: "Rentman", kind: "Rental system", mark: "/logos/rentman-mark.svg" },
  { name: "Booqable", kind: "Rental system", mark: "/logos/booqable-mark.svg" },
  { name: "HireHop", kind: "Rental system", mark: "/logos/hirehop-mark.svg" },
  { name: "Google Calendar", kind: "Calendar", mark: "/logos/google-calendar-mark.png" },
  { name: "Outlook Calendar", kind: "Calendar", mark: "/logos/outlook-mark.png", fill: true },
  { name: "Xero", kind: "Accounting", mark: "/logos/xero-mark.svg", fill: true },
  { name: "Flex", kind: "Rental system", mark: "/logos/flex-mark.jpg", fill: true, ask: true },
  { name: "Goodshuffle Pro", kind: "Rental system", mark: "/logos/goodshuffle-mark.webp", fill: true, ask: true },
  { name: "Point of Rental", kind: "Rental system", mark: "/logos/point-of-rental-mark.png", fill: true, ask: true },
  { name: "Rentopian", kind: "Rental system", mark: "/logos/rentopian-mark.webp", fill: true, ask: true },
];
